import "@babel/polyfill";
import { LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import axios from 'axios';
import $ from "jquery";
import React, { Component } from 'react';
import { BrowserRouter, Redirect } from 'react-router-dom';
import Messages_de from './assets/localization/de.json';
import backgroundImage from './assets/themes/default/img/background.jpg';
import { Context } from './components/assets/Context';
import Routes from './components/assets/Routes';
import Sidebar from './components/assets/Sidebar';

loadMessages(Messages_de, 'de-AT');

class App extends Component {
	constructor(props) {
		super(props);
		var user = localStorage.getItem('user');
		this.state = {
			login: this.login,
			logout: this.logout,
			user: {
				isLoggedIn: (user) ? true : false,
				roles: [],
				rolesVisible: []
			},
			userHasRole: this.userHasRole,
			redirectIf401: this.redirectIf401
		};
	}
	componentDidMount() {
		var user = localStorage.getItem('user');
		if (user) {
			user = JSON.parse(user);
			this.login(user, null);
		}
	}
	login = (user, history) => {
		user.isLoggedIn = true;
		user.rolesVisible = JSON.parse(JSON.stringify(user.roles));
		user.rolesVisible.forEach(function (role, index) {
			if (role.visible) {
				if (role.items.length) {
					role.items.forEach(function (roleChild, indexChild) {
						if (!roleChild.visible) {
							user.rolesVisible[index].items.splice(indexChild, 1);
						}
					});
				}
			} else {
				user.rolesVisible.splice(index, 1);
			}
		});
		this.setState(state => ({
			user: user
		}));
		localStorage.setItem('user', JSON.stringify(user));
		document.getElementsByTagName('body')[0].classList.remove('login');
		document.getElementsByTagName('body')[0].classList.add('isLoggedIn');
		setTimeout(function () {
			var loginEl = document.getElementById('login');
			if (loginEl) loginEl.classList.add('positionHidden');
		}, 500);
		var redirectPath;
		if (this.state.user.rolesVisible && this.state.user.rolesVisible.length) redirectPath = this.state.user.rolesVisible[0].url;
		if (!redirectPath || redirectPath === '') redirectPath = '/Inhalte';

		if(history){
			if(history.location.state && history.location.state.from)
				history.push(history.location.state.from);
			else
				history.push(redirectPath);
		}
	}
	logout = () => {
		localStorage.removeItem('user');
		document.getElementsByTagName('body')[0].classList.remove('isLoggedIn');
		document.getElementsByTagName('body')[0].classList.add('login');
		if ( document.getElementById('login') ) {
			document.getElementById('loginFormSubmit').disabled = false;
			document.getElementById('loginFormSubmit').style.opacity = 1;
			document.getElementById('login').classList.remove('positionHidden');
		}
		this.setState(state => ({
			user: {
				isLoggedIn: false,
				roles: [],
				rolesVisible: []
			}
		}));
		axios({
			method: 'GET',
			url: window.variables.url +'/rest/admin/logout',
			withCredentials: true
		});
		return <Redirect to="/Login" />
	}
	render() {
		window.onload = function () {
			$("#loading").remove();
			$('#app').removeClass('invisible');
		}
		return (
			<Context.Provider value={this.state}>
				<LocalizationProvider language="de-AT">
					<BrowserRouter basename={process.env.NODE_ENV === 'production' ? window.variables.pathAdmin : ''}>
						<div className="invisible" id="app" style={{backgroundImage:'url("'+ backgroundImage +'")'}}>
							<Sidebar />
							<Routes />
						</div>
					</BrowserRouter>
				</LocalizationProvider>
			</Context.Provider>
		);
	}

	userHasRole = (component) => {
		return this.state.user.roles.some(function (role) {
			if (role.items.length) {
				return role.items.some(function (roleChild) {
					return roleChild.component === component;
				});
			}
			return role.component === component;
		});
	}	

	//if error has status code 401 user is logged out and true is returned
	//false otherwise
    redirectIf401 = (error) => {
        if(error.response && error.response.status === 401) {
			this.logout();
			window.handleErrorResponse(error);
            return true;
		}
		return false;
    }
}

export default props => (
	<Context.Consumer>
		{({login, logout, user}) => <App {...props} login={login} logout={logout} user={user} />}
	</Context.Consumer>
);
